<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentUrl /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentUrl from '@/components/team/dashboard/modules/activity/url/ContentUrl.vue'

export default 
{
  name: 'Url',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentUrl
  }
}
</script>
<style>

</style>